import { motion } from "framer-motion";
import WebnorTVImg from "../../assets/imgs/webnortv.svg";

export default function WebnorTVSection() {
  return (
    <section className="relative overflow-hidden py-16 lg:py-24 bg-gradient-to-r from-[#0f172a] to-[#1a56db]">
      {/* Decorative glows */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-white/5 blur-[120px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#1a56db]/20 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left: Text Content */}
          <div className="order-2 lg:order-1">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="flex flex-col items-start text-left"
            >
              {/* Headline */}
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6 leading-tight">
                TV ao vivo + Internet.<br />Tudo em um.
              </h2>

              {/* Subtitle */}
              <p className="text-lg md:text-xl font-light text-white/90 mb-10 max-w-lg">
                A melhor internet com a melhor TV Ao vivo
              </p>

              {/* Pill Badges */}
              <div className="flex flex-wrap gap-3">
                <span className="px-5 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold backdrop-blur-md shadow-sm">
                  120+ Canais
                </span>
                <span className="px-5 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold backdrop-blur-md shadow-sm">
                  Filmes e Séries
                </span>
                <span className="px-5 py-2 rounded-full bg-white/10 border border-white/20 text-white text-sm font-semibold backdrop-blur-md shadow-sm">
                  Qualquer Dispositivo
                </span>
              </div>
            </motion.div>
          </div>

          {/* Right: TV Image */}
          <div className="order-1 lg:order-2 flex justify-center items-center relative w-full">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="w-full max-w-[500px] lg:max-w-[650px] relative"
            >
              {/* Subtler Glow behind TV */}
              <div className="absolute inset-0 bg-[#1a56db]/30 blur-[80px] rounded-[30px] -z-10" />

              <img
                src={WebnorTVImg}
                alt="WebnorTV Interface"
                className="w-full h-auto object-contain drop-shadow-2xl relative z-10 scale-[1.25] lg:scale-[1.35] origin-center"
              />
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
}
